<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Dedication--Front-Matter- _idGenParaOverride-1"><span class="ital">This one is for Imogen Taylor, with huge thanks</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Carer37.vue?50007307